import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MultiSelect from "../extra/MultiSelect";
import CountrySelect from "../extra/CountrySelect";
import { seedData } from "../../libs/Libs";

export default function Form({
    title,
    roles = [],
    users = [],
    defaultValues = {},
    onSubmit = () => { },
    onChange = () => { },
    back = () => { },
}) {
    const {
        register,
        handleSubmit,
        control,
        watch,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({
        defaultValues,
        mode: "all",
        shouldFocusError: true,
    });

    const [open, setOpen] = useState(false);
    const isActive = watch("is_active");

    const handleFormSubmit = (data) => {
        console.log("GROUP", data)
        onSubmit(data);
    };

    return (
        <Box sx={{ pb: 2 }}>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <RFG name="first_name" label="First Name" control={control}
                            rules={{
                                required: true, maxLength: 100,
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid first name format",
                                }
                            }} className="mb-2">
                            <input autoComplete="off" placeholder="First name" />
                        </RFG>
                        <RFG name="last_name" label="Last name" control={control}
                            rules={{
                                required: true, maxLength: 100,
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid last name format",
                                }
                            }} className="mb-2">
                            <input autoComplete="off" placeholder="Last name" />
                        </RFG>
                        <Box display={'flex'} gap={2}>
                            <Box minWidth={100}>
                                <RFG
                                    name="country_code"
                                    label="Phone Code"
                                    control={control}
                                    rules={{ required: true }}
                                //error={errors.country_code?.message}
                                >
                                    <CountrySelect
                                        defaultValue={defaultValues.country_code}
                                        labelKey="dial_code"
                                        valueKey="dial_code"
                                        //onValueChange={(country) => setValue("country_code", country.value)}
                                        onValueChange={(country) => {
                                            // Set and validate the same field name
                                            const value = country?.value || "";
                                            setValue("country_code", value, { shouldValidate: true });
                                            if (value) clearErrors("country_code");
                                            // no setError here; RHF required rule shows the message on submit
                                        }}
                                    />
                                </RFG>
                            </Box>
                            <Box width={1}>
                                <RFG
                                    name="phone"
                                    label="Phone"
                                    control={control}
                                    rules={{
                                        required: true,
                                        pattern: {
                                            value: /^[0-9]{5,15}$/,
                                            message: "Phone number must be between 5 and 15 digits",
                                        },
                                        maxLength: {
                                            value: 15,
                                            message: `Cannot exceed 15 digits`,
                                        }
                                    }}
                                >
                                    <input placeholder="e.g. 1234567890" autoComplete="off" />
                                </RFG>
                            </Box>
                        </Box>

                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <RFG name="username" label="Email" control={control} rules={{
                            required: true, maxLength: 500,
                            pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                message: "Enter a valid email username",
                            }
                        }} className="mb-2">
                            <input autoComplete="off" placeholder="Email as Username" />
                        </RFG>
                        {/* <RFG name="department" label="Department" control={control} rules={{ required: true }} className="mb-2">
                            <select>
                                <option value="">Select Department</option>
                                {seedData(4, "Department").map((company) => (
                                    <option key={company.id} value={company.id}>
                                        {company.name}
                                    </option>
                                ))}
                            </select>
                        </RFG> */}
                        <RFG name="group" label="Main Role" control={control} rules={{}} className="mb-2" error={errors.project?.message}>
                            <MultiSelect
                                isMultiSelect={false}
                                options={(roles || []).map((role) => ({ id: role.name, label: role.name }))}
                                value={watch("group")}
                                defaultValue={defaultValues?.group?.map(r => r.name) || ["SuperAdmin"]}
                                onValueChange={(value) => {
                                    console.log("value", value)
                                    setValue("group", value, { shouldValidate: true });
                                    if (value && value.length) clearErrors("role");
                                }}
                            />
                        </RFG>
                        <Box sx={{ my: 2 }} display="flex">
                            <RFG name="is_active" label="Active" control={control} className="mb-2">
                                <input
                                    type="checkbox"
                                    onChange={(e) => setValue("is_active", e.target.checked)}
                                    checked={isActive}
                                />
                            </RFG>
                        </Box>
                        <Box textAlign="right" sx={{ my: 4 }}>
                            <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                Back
                            </Button>
                            <Button
                                onClick={(e) => setValue("action", e.target.innerText)}
                                className="btn-primary"
                                type="submit"
                            >
                                {"Save"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}
